import type { FtpUser, FtpUserCreateDTO, FtpUserID, FtpUserRepositoryInterface, FtpUserSearchResult, FtpUserUpdateDTO, FtpUserWithLogs } from "./interfaces";

import { AxiosInstance } from 'axios';

export default class FtpUserRepository implements FtpUserRepositoryInterface {
    constructor(
        private axios: AxiosInstance,
    ){}
    
    public async createFtpUser(dto: FtpUserCreateDTO): Promise<FtpUser> {
        const response = await this.axios.post('/ftp/ftp-users', dto);

        return response.data;
    }
    
    public async updateFtpUser(id: FtpUserID, dto: FtpUserUpdateDTO): Promise<void> {
        await this.axios.patch(`/ftp/ftp-users/${id}`, dto);
    }

    public async deleteFtpUser(id: FtpUserID): Promise<void> {
        await this.axios.delete(`/ftp/ftp-users/${id}`);
    }

    public async searchFtpUsers(page: number, search?: string | undefined, itemsPerPage?: number): Promise<FtpUserSearchResult> {
        page = page < 1 ? 1 : page;

        const searchParams = new URLSearchParams();
        searchParams.append('page', page.toString());
        if (itemsPerPage && itemsPerPage > 0) {
            searchParams.append('itemsPerPage', String(itemsPerPage));
        }
        if (search) {
            searchParams.append('search', search);
        }

        const response = await this.axios.get(`/ftp/ftp-users?${searchParams.toString()}`);

        return response.data;
    }

    public async findOneById(id: FtpUserID): Promise<FtpUserWithLogs> {
        const response = await this.axios.get(`/ftp/ftp-users/${id}`);

        return response.data;
    }
}